import { Component, OnDestroy, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ProfileService } from '../../services/profile/profile.service';
import { ApplicationService } from '../../services/application.service';
import { TokenStorageService } from '../../services/token-storage/token-storage.service';
import { Location } from '@angular/common';
import { takeUntil, Subject } from 'rxjs';
import { FormGroup } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { DialogData } from '../../models/dialog-data';
import { RiwayatProfile } from '../../models/riwayat-profile.t';
import { DownloadService } from '../../services/download/download.service';
import { RiwayatProgressDetail } from 'src/app/models/riwayat-progress-detail.t';
import { RiwayatProgress } from 'src/app/models/riwayat-progress.t';

@Component({
  selector: 'app-riwayat-progress',
  templateUrl: './riwayat-progress.component.html',
  styleUrls: ['./riwayat-progress.component.css']
})
export class RiwayatProgressComponent implements OnInit, OnDestroy {

  @ViewChild('stepper')
  stepper!: MatStepper;

  processing = false;

  currentStep = 0;
  isLoading = false;
  onDestroy$ = new Subject<void>();
  datas = [];
  progressId = '';
  riwayatProfile: RiwayatProfile | undefined;

  positionfirstFormGroup: FormGroup = Object.create(null);

  constructor(
    public tokenStorageService: TokenStorageService,
    private applicationService: ApplicationService,
    private profileService: ProfileService,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private location: Location,
    private downloadService: DownloadService,
  ) { }

  ngOnInit(): void {
    this.route.paramMap.pipe(takeUntil(this.onDestroy$)).subscribe((params) => {
      this.progressId = params.get('progressId')!;
      this.reload();
    });
  }

  reload() {
    this.isLoading = true;
    this.profileService.getData(this.progressId).subscribe((data) => {
      this.riwayatProfile = data;
      let index = 0;
      if (data && data.progressList) {
        for (let i = 0; i < data.progressList.length; i++) {
          if (data.progressList[i].completed === 0) {
            index = i;
            break;
          }
        }
      }
      this.setStepper(index);
      this.isLoading = false;
    });
  }

  public setStepper(index: number): void {
    this.processing = true;
    setTimeout(() => {
      this.currentStep = index;
      this.processing = false;
    }, 1000);
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  back(): void {
    this.location.back();
  }

  displayInfo(message: string, closeFormDialog: boolean) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      disableClose: true,
      data: <DialogData>{
        title: 'Informasi',
        message: message,
        okLabel: 'OK',
        isConfirmation: false,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (closeFormDialog) {
        // this.matDialogRef.close(true);
      }
    });
  }

  selectFile(event: any, item: RiwayatProgressDetail): void {
    if (event.target.files.length > 0) {
      item.isLoading = true;
      this.profileService.upload(item.id, event.target.files, 'progress').subscribe((data) => {
        this.displayInfo('Perubahan data berhasil disimpan', false);
        item.isLoading = false;
        if (data.dataObjects) {
          this.reload();
        }
      });
    }
  }

  download(item: RiwayatProgressDetail) {
    item.isLoading = true;
    this.downloadService
      .download(4, item.filepath || '', item.filename || '')
      .subscribe(
        (response) => {
          item.isLoading = false;
          console.log(response);
          var binaryData = [];
          binaryData.push(response.data);
          var url = window.URL.createObjectURL(
            new Blob(binaryData, { type: "application/*" })
          );
          var a = document.createElement("a");
          document.body.appendChild(a);
          a.setAttribute("style", "display: none");
          a.setAttribute("target", "blank");
          a.href = url;
          a.download = response.filename;
          a.click();
          window.URL.revokeObjectURL(url);
          a.remove();
        },
        (error) => {
          console.log(error);
        }
      );
  }

  confirmDialog(item: RiwayatProgressDetail) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      disableClose: true,
      data: <DialogData>{
        title: 'Peringatan',
        message: 'Apakah Anda yakin akan menghapus data ini?',
        isConfirmation: true,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        item.isLoading = true;
        this.profileService.deleteProgress(item).subscribe(() => {
          item.isLoading = false;
          this.reload();
        });
      }
    });
  }

  confirmCompleteStep(item: RiwayatProgress) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      disableClose: true,
      data: <DialogData>{
        title: 'Peringatan',
        message: 'Apakah Anda yakin akan menyelesaikan step ini?',
        isConfirmation: true,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.profileService.completeStep(item).subscribe(() => {
          this.reload();
        });
      }
    });
  }

}
